export default {
  mainView: {
    name: 'Shenzhen Laikangning Medical Technology Co., Ltd. - Real time monitoring',
    onlineUser: 'Online Users',
    sysSet: 'System Settings',
    refresh: 'Refresh',
    exitFs: 'Exit Fullscreen',
    fs: 'Fullscreen',
    confirmRefresh: 'Are you sure you want to refresh the interface?',
    refreshSuccess: 'Refresh successful',
    tips: 'Tips',
    closePage: 'Close this page',
    notUser: 'No guardianship users currently available',
    tips1: 'You do not have permission to use real-time monitoring',
    tips2: 'Login has expired. Please close this page and reopen it from the management system',
    tips3: 'Login failed, please close the window and reopen it.',
  },
  userList: {
    notUser: 'No Online Users',
    id: 'ID',
    name: 'Name',
    phone: 'Tel',
    chat: 'Chat',
    new: 'New',
  },
  contactInfo: {
    contInfo: 'ContInfo',
    pregTel: 'PregTel',
    drTel: 'DrTel',
    hospName: 'HospName',
    hospTel: 'HospTel',
    close: 'Close',
  },
  chatMessage: {
    placeholder: 'enter the message you want to send',
    tips: 'You are communicating with {name}',
  },
  settings: {
    cm: 'cm',
    cmTips: 'Pixels per Centimeter',
    fhrRange: 'FHR Range',
    speed: 'Chart Speed',
    fhr: 'FHR',
    bed: 'Bed',
    bedTips: 'Monitors per Display',
    alarmSet: 'Alarm Settings',
    save: 'Save',
    saveSuccess: 'Save Success',
    fhrAlarm: 'Fhr Alarm',
  },
  fetalMonitor: {
    fhr1: 'FHR1',
    fhr2: 'FHR2',
    uc: 'UC',
    fm: 'FM',
    fetal: 'Manual/Auto',
    fhr1Low: 'FHR1 Low',
    fhr1High: 'FHR1 High',
    fhr2Low: 'FHR2 Low',
    fhr2High: 'FHR2 High',
    dueDate: 'due Date',
    weeks: 'weeks',
  },
}
